// Which pipeline appointment field a "Log appointment" should fill (so the day-before confirm task is created).
// when is the datetime-local string from the modal (same format as the pipeline form fields).
export function pipelineApptPatch(entry, type, when) {
  if (!entry || entry.sample || !when) return null;
  if (entry.kind === 'buyer') return (type === 'Buyer consult' || type === 'Showing') ? { appointmentAt: when } : null;
  return type === 'Listing appointment' ? { listingAppointmentAt: when } : null;
}
